module.exports = __webpack_public_path__ + "static/media/low_power.f540ba90.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene0/asset/low_power.png
// module id = 1750
// module chunks = 0